import React from 'react';
import CardLayout from './CardLayout';

interface IKPICard {
    value: string | number;
    text: string;
    img?: string;
    classes?: string;
    titleClasses?: string;
}

export function KPICard({ value, text, img, classes, titleClasses }: IKPICard) {
    return (
        <CardLayout classBody="text-center p-2" classCard={`${classes}`}>
            {!!img && <img src={img} alt={text} width={24} />}
            <h6 className={`mb-1 mt-1 ${titleClasses}`}>{value ?? 0}</h6>
            <p className="mb-0">{text}</p>
        </CardLayout>
    );
}
